import React from "react"
import styled from "@emotion/styled"
import { css } from "@emotion/react"
import Section from "src/components/Section"
import Grid from "src/components/Grid"
import TextLockup from "src/components/TextLockup"
import ScrollEntrance from "src/components/ScrollEntrance"
import ResponsiveComponent from "src/components/ResponsiveComponent"
import Image from "src/components/Image"
import { mq, globals } from "src/styles"

const Wrapper = styled(Section)`
  text-align: center;
  ${({ vertical }) =>
    `
    ${globals.verticalSpacing("padding-top", vertical)}
    ${globals.verticalSpacing("padding-bottom", vertical)}
  `}
  ${({ horizontal }) =>
    `
    ${globals.verticalSpacing("padding-left", horizontal)}
    ${globals.verticalSpacing("padding-right", horizontal)}
  `}
  ${mq.mediumAndBelow} {
    ${({ hideMobile }) => (hideMobile && "display: none")}
  }
  ${mq.largeAndUp} {
    ${({ hideDesktop }) => (hideDesktop && "display: none")}
  }
`

const IntroText = styled(TextLockup)`
  margin-bottom: 30px;
  ${mq.largeAndUp} {
    ${globals.verticalSpacing("margin-bottom", 0.5)}
  }
  h1,
  h2,
  h3 {
    max-width: 20em;
  }
  h4,
  h5 {
    max-width: 26em;
  }
  h6 {
    max-width: 16em;
  }
  p {
    max-width: 40em;
  }
  ${mq.mediumAndUp} {
    padding-right: 20px;
  }
`

const CollageImage = styled(Image)`
  margin-top: var(--site-margins);
  ${mq.mediumAndBelow} {
    flex-shrink: 0;
    margin-top: 0;
    margin-right: var(--site-margins);
    // ${({ aspectRatio }) => `
    //   flex-grow: ${aspectRatio};
    //   width: ${50 * aspectRatio}%;
    // `}
  }
`

const ScrollImages = styled.div`
  padding: 0 0 0 var(--site-margins);
  max-width: 100%;
  width: 100vw;
  overflow-x: auto;
  // overflow-y: hidden;
  display: flex;
  ${mq.mediumAndUp} {
    padding: 0 ${100 / 14}vw;
  }
`

const ImageCollage = ({
  className,
  nextTheme,
  prevTheme,
  theme,
  spacing,
  isFirstSection,
  headline,
  introText,
  images,
  id,
  hideMobile,
  hideDesktop,
}) => {
  const sizes = "(min-width: " + mq.mediumBreakpoint + "px) 50vw, 86vw"

  return (
    <Wrapper
      className={className}
      prevTheme={prevTheme}
      setTheme={theme}
      nextTheme={nextTheme}
      isFirstSection={isFirstSection}
      id={id}
      vertical={spacing?.vertical}
      horizontal={spacing?.horizontal}
      hideMobile={hideMobile}
      hideDesktop={hideDesktop}
    >
      <ResponsiveComponent
        small={
          <>
            <Grid small="m [1] m" medium="1 [12] 1">
              <IntroText
                eyebrow={introText.eyebrow}
                text={introText._rawText}
                alignment="left"
                transitionIn={false}
              />
            </Grid>
            <ScrollImages>
              {images.map((image, index) => {
                const aspectRatio =
                  image?.asset?.metadata?.dimensions?.aspectRatio
                return (
                  <div
                    css={css`
                      flex-grow: ${aspectRatio};
                      width: calc(${50 * aspectRatio}% + 20px);
                      padding-right: 20px;
                      flex-shrink: 0;
                    `}
                  >
                    <CollageImage
                      key={image._key}
                      aspectRatio={aspectRatio}
                      image={image?.asset?.gatsbyImageData}
                      sizes={sizes}
                      rounded
                    />
                  </div>
                )
              })}
            </ScrollImages>
          </>
        }
        medium={
          <Grid
            small="[1]"
            medium="1 [6] m [6] 1"
            vAlign="top"
            as={ScrollEntrance}
          >
            <div>
              <IntroText
                eyebrow={introText.eyebrow}
                text={introText._rawText}
                alignment="left"
                transitionIn={false}
              />
              <CollageImage
                image={images[0]?.asset?.gatsbyImageData}
                sizes={sizes}
                rounded
              />
            </div>
            <div>
              <CollageImage
                image={images[1]?.asset?.gatsbyImageData}
                sizes={sizes}
                rounded
              />
              <Grid small="[1]" medium="[5] 1" large="[4] 2">
                <div>
                  <CollageImage
                    image={images[2]?.asset?.gatsbyImageData}
                    sizes={sizes}
                    rounded
                  />
                </div>
              </Grid>
            </div>
          </Grid>
        }
      />
    </Wrapper>
  )
}

export default ImageCollage
